"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monthsFromToday = exports.getDateStringFromTimestamp = exports.getAnalyticsDateStringFromTimestamp = exports.daysFromToday = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _zhCN = _interopRequireDefault(require("date-fns/locale/zh-CN"));
const getDateStringFromTimestamp = _ref => {
  let {
    timestamp,
    locale,
    time = false,
    utc = false
  } = _ref;
  if (!timestamp) return '';
  let timestampDate = new Date(timestamp);
  if (utc) {
    timestampDate = new Date(timestampDate.getTime() + 60000 * timestampDate.getTimezoneOffset());
  }
  const options = {};
  if (locale === 'zh') {
    options.locale = _zhCN.default;
  }
  let formatString;
  if (locale === 'zh') {
    formatString = time ? 'yyyy年MM月dd日HH时mm分' : 'yyyy年MM月dd日';
  } else {
    formatString = time ? 'dd-MMM-yy HH:mm' : 'dd-MMM-yy';
  }
  const dateString = (0, _format.default)(timestampDate, formatString, options);
  return dateString;
};
exports.getDateStringFromTimestamp = getDateStringFromTimestamp;
const getAnalyticsDateStringFromTimestamp = timestamp => (0, _format.default)(new Date(timestamp), 'yy-MM-dd');
exports.getAnalyticsDateStringFromTimestamp = getAnalyticsDateStringFromTimestamp;
const daysFromToday = days => {
  const to = new Date();
  const from = new Date(to.getTime());
  from.setDate(to.getDate() - days);
  return {
    to,
    from
  };
};
exports.daysFromToday = daysFromToday;
const monthsFromToday = months => {
  const to = new Date();
  const from = new Date(to.getTime());
  from.setMonth(to.getMonth() - months);
  return {
    to,
    from
  };
};
exports.monthsFromToday = monthsFromToday;